import React, { Component, Fragment } from 'react';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image, Font, BlobProvider, PDFDownloadLink } from '@react-pdf/renderer';
import utils from "../../../ProducaoEP/utils/utils";
import utilsExport from '../../../../utils/utilsExport';

export default class TabelaConsolidadaPorUnidade extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };

    }

    HeaderLista = (styles) => {
        let { radioChecked, ultimoMesApurado, mesSelecionado } = this.props;
        return (
            <Fragment>
                <Text style={styles.header} fixed>
                    {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                </Text>
                {/* <Image
                    style={styles.image}
                    src="/assets/images/logotipo.png"
                /> */}
                <Text style={styles.title}>Relatório SIGEM</Text>
                <Text style={styles.author}>{new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}</Text>
                <Text style={styles.resumo}>Mês Selecioando: { mesSelecionado }</Text>
                <Text style={styles.resumo}>Último mês apurado (realizado): { ultimoMesApurado }</Text>
                <Text style={styles.resumo}>Tipo: { radioChecked }</Text>
                <Text style={styles.resumo}>Período: { `Janeiro à ${mesSelecionado}` }</Text>
            </Fragment>
        )
    }

    TabelaRealizados = (styles, modalidades, total, tipoFinanciamento) => {

        let titulo;
        if(tipoFinanciamento === 'pago') titulo = 'Pagas';
        else if(tipoFinanciamento === 'regimental') titulo = 'Gratuidade Regimental';
        let mesReferencia = <Text style={styles.textCaptalize}>{ `( ${utilsExport.exibeMes(this.props)} )` }</Text>

        return (
            <Fragment>
                <View style={styles.table} break>

                    <View style={styles.tableRowUnidadeHeader}>
                        <Text style={styles.unidadeHeader}>{`Análise ${titulo} EP (Consolidado por Unidade)`}</Text>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableColHeaderMetaRealizadoModalidades}>
                            <Text style={styles.tableCellMetaRealizadoHeader}></Text>
                        </View>
                        <View style={styles.tableColCabecalho2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Matrículas {mesReferencia}</Text>
                        </View>
                        <View style={styles.tableColCabecalho2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Horas {mesReferencia}</Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableColHeaderMetaRealizadoModalidades}>
                            <Text style={styles.tableCellMetaRealizadoHeader}></Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader1}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Meta</Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Realizado</Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>%</Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader1}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Meta</Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Realizado</Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>%</Text>
                        </View>
                    </View>

                    {/* <View style={styles.tableRow}>
                        <View style={styles.tableColHeaderModalidades}>
                            <Text style={styles.tableCellHeader}>Modalidades</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>%</Text>
                        </View>
                    </View> */}
                    {
                        Object.keys(modalidades).map(modalidade => {
                            let meta = modalidades[modalidade]['meta'];
                            let realizado = modalidades[modalidade]['realizado'];

                            let totalMetaMatriculas = meta[`matricula_${tipoFinanciamento}`]
                            let totalRealizadoMatriculas = realizado[`matricula_${tipoFinanciamento}`]
                            let totalMetaHoras = meta[`hora_${tipoFinanciamento}`]
                            let totalRealizadoHoras = realizado[`hora_${tipoFinanciamento}`]

                            // verifica modalidades com valores zerados para omitir a visualização
                            let valoresZerados = totalMetaMatriculas + totalRealizadoMatriculas + totalMetaHoras + totalRealizadoHoras
                            if(valoresZerados === 0) return;

                            return (
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColModalidades}>
                                        <Text style={styles.tableCellModalidades}>{utilsExport.retiraCodigoUnidade(modalidade)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalMetaMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataPercentualExport(totalMetaMatriculas, totalRealizadoMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalMetaHoras)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoHoras)}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataPercentualExport(totalMetaHoras, totalRealizadoHoras)}</Text>
                                    </View>
                                </View>
                            )
                        })
                    }
                    {this.exibeTotais(styles, total, tipoFinanciamento)}
                </View>
                <View>
                    <Text style={styles.tableCell}>* Observações: {utilsExport.exibeObservacao(this.props)}</Text>
                </View>
            </Fragment>
        )
    }

    exibeTotais = (styles, totais, tipoFinanciamento) => {
        let { meta, realizado } = totais;
        let totalMetaMatriculas = meta[`matricula_${tipoFinanciamento}`]
        let totalRealizadoMatriculas = realizado[`matricula_${tipoFinanciamento}`]
        let totalMetaHoras = meta[`hora_${tipoFinanciamento}`]
        let totalRealizadoHoras = realizado[`hora_${tipoFinanciamento}`]

        let viewTotais =  (
            <View style={styles.tableRowTotais}>
                <View style={styles.tableColModalidades}>
                    <Text style={styles.tableCellModalidades}>{}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalMetaMatriculas)}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoMatriculas)}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataPercentualExport(totalMetaMatriculas, totalRealizadoMatriculas)}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalMetaHoras)}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoHoras)}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataPercentualExport(totalMetaHoras, totalRealizadoHoras)}</Text>
                </View>
            </View>
        )
        return viewTotais
    }

    formataRealizadoMetas = (realizados, metas) => {
        let novo = realizados.map((realizado) => {
            let unidadeFiltro = metas.filter(meta => meta.unidade === realizado.unidade)[0];
            let modalidade = [...new Set([...Object.keys(realizado.modalidades), ...Object.keys(unidadeFiltro.modalidades)])]
            let isVazio = {
                matricula_regimental: 0,
                matricula_nao_regimental: 0,
                matricula_pago: 0,
                hora_regimental: 0,
                hora_nao_regimental: 0,
                hora_pago: 0
            }
            let novasModalidades = {}
            modalidade.map(modal => {
                novasModalidades[modal] = {
                    meta: unidadeFiltro.modalidades[modal] === undefined ? isVazio : unidadeFiltro.modalidades[modal],
                    realizado: realizado.modalidades[modal] === undefined ? isVazio : realizado.modalidades[modal]
                }
            })
            realizado.modalidades = novasModalidades;
            return realizado;
        })
        return realizados;
    }

    calculaTotal = (realizados) => {
        let totaisObj = {}
        let modalidades = realizados;
        let obj = {
            meta: {
                matricula_regimental: 0,
                matricula_nao_regimental: 0,
                matricula_pago: 0,
                hora_regimental: 0,
                hora_nao_regimental: 0,
                hora_pago: 0
            },
            realizado: {
                matricula_regimental: 0,
                matricula_nao_regimental: 0,
                matricula_pago: 0,
                hora_regimental: 0,
                hora_nao_regimental: 0,
                hora_pago: 0
            }
        }
        Object.keys(modalidades).map(modalidade => {
            Object.keys(modalidades[modalidade]['meta']).map(financiamento => obj['meta'][financiamento] += modalidades[modalidade]['meta'][financiamento])
            Object.keys(modalidades[modalidade]['realizado']).map(financiamento => obj['realizado'][financiamento] += modalidades[modalidade]['realizado'][financiamento])
        })

        return obj
    }

    formataRealizadoMetasV2 = (realizados, metas) => {
        let unidadesEncontradas = {}
        realizados.map(realizado => {
            let modalidades = realizado.modalidades;
            let unidade = realizado.unidade;
            Object.keys(modalidades).map(modalidade => {
                if(unidade === 'DR') return // não somar com o DR
                if(unidadesEncontradas.hasOwnProperty(unidade)) {
                    Object.keys(modalidades[modalidade]['meta']).map(financiamento => unidadesEncontradas[unidade]['meta'][financiamento] += modalidades[modalidade]['meta'][financiamento])
                    Object.keys(modalidades[modalidade]['realizado']).map(financiamento => unidadesEncontradas[unidade]['realizado'][financiamento] += modalidades[modalidade]['realizado'][financiamento])
                }
                else {
                    unidadesEncontradas[unidade] = modalidades[modalidade]
                }
            })
            
        })
        realizados = unidadesEncontradas
        return realizados;
    }

    newStyle = (styles) => {
        styles.tableColHeader.width = "8.8%"
        styles.tableCol.width = "8.8%"
        styles.tableColTotal.width = "8.8%"
        styles.tableColHeaderModalidades.width = "18.6%"
        styles.tableColModalidades.width = "18.6%"
        styles.unidadeHeader.width = "71.4%"
        styles.tableColCabecalho2.width = "26.4%"
        styles.tableColHeaderMetaRealizadoModalidades.width = "18.6%"
        styles.tableColMetaRealizadoHeader1.width = "8.8%"
        styles.tableColMetaRealizadoHeader2.width = "8.8%"
        return { ...styles };
    }

    render() {
        let { realizados, metas, styles } = this.props
        if(realizados) realizados = this.formataRealizadoMetasV2(realizados, metas);
        let total = this.calculaTotal(realizados);
        let newStyle = this.newStyle(JSON.parse(JSON.stringify(styles)));
        return (
            <Fragment>
                {
                    this.TabelaRealizados(newStyle, realizados, total, 'pago')
                }
                {
                    this.TabelaRealizados(newStyle, realizados, total, 'regimental')
                }
            </Fragment>
        );
    }
}
